import { render } from "./LoadingIcon.vue?vue&type=template&id=86b54dac&scoped=true"
const script = {}

import "./LoadingIcon.vue?vue&type=style&index=0&id=86b54dac&scoped=true&lang=css"

import exportComponent from "/home/runner/work/uup/uup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86b54dac"]])

export default __exports__